import { render, staticRenderFns } from "./EditorSample.vue?vue&type=template&id=bf2af2fc&scoped=true"
import script from "./EditorSample.vue?vue&type=script&lang=js"
export * from "./EditorSample.vue?vue&type=script&lang=js"
import style0 from "./EditorSample.vue?vue&type=style&index=0&id=bf2af2fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2af2fc",
  null
  
)

export default component.exports